import { createElement, Children } from 'react'

const Slot = ({ name, ...rest }) =>
  Children.toArray(createElement('div', rest).props.children)

Slot.displayName = 'Slot'

export default Slot
